import { FetchLoader } from './fetch'
import { XhrLoader } from './xhr'
import { LoaderType, ResponseType } from './types'

export {
  FetchLoader,
  XhrLoader,
  LoaderType,
  ResponseType
}

export class NetLoader {
  type = LoaderType.FETCH

  retryCount = 0

  loading = false

  _canceled = false

  _retryTimer = null

  constructor (opts) {
    this._opts = Object.assign({
      retry: 0,
      retryDelay: 0 // ms
    }, opts)
    let Loader = FetchLoader

    if (
      this._opts.loaderType === LoaderType.XHR ||
      !FetchLoader.isSupported()
    ) {
      Loader = XhrLoader
      this.type = LoaderType.XHR
    }

    this.loader = new Loader()
  }

  get loading () {
    return this.loader.loading
  }

  isFetch () {
    return this.type === LoaderType.FETCH
  }

  static isFetchSupport () {
    return FetchLoader.isSupported()
  }

  load (url, config = {}) {
    if (this.loading) return Promise.resolve()

    if (typeof url === 'string') {
      config.url = url
    } else {
      config = url
    }

    config = Object.assign({}, config, this._opts)

    if (config.requestFilter) {
      config = config.requestFilter(config) || config
    }

    let {
      retry,
      retryDelay,
      onRetryError,
      ...rest
    } = config

    this.retryCount = 0
    this._canceled = false
    this.loading = true

    retry = retry || this._opts.retry
    retryDelay = retryDelay || this._opts.retryDelay

    return new Promise((resolve, reject) => {
      const request = async () => {
        try {
          const response = await this.loader.load(rest)
          this.loading = false
          resolve(response)
        } catch (error) {
          if (this._canceled) return

          error.loaderType = this.type
          error.retryCount = this.retryCount

          if (onRetryError && this.retryCount > 0) onRetryError(error, this.retryCount, retry)

          this.retryCount++

          if (this.retryCount <= retry) {
            clearTimeout(this._retryTimer)
            this._retryTimer = setTimeout(request, retryDelay)
            return
          }

          this.loading = false
          reject(error)
        }
      }

      request()
    })
  }

  cancel () {
    clearTimeout(this._retryTimer)
    this._canceled = true
    this.loading = false
    return this.loader.cancel()
  }
}
